import React, { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useAudioPlayer } from '../pages/Main/components/useAudioPlayer'
import { AUDIO_LAND_URL } from '../constants/audioAssets'

/** Set in `KingdomMusicPlayer` so routes like `/hex-battle` can pause land BGM before playing their own track. */
let kingdomMusicAudioEl: HTMLAudioElement | null = null

export function stopKingdomAudio(): void {
  kingdomMusicAudioEl?.pause()
}

/** Paths where kingdom/land background music should play (main map + all building pages). */
const KINGDOM_MUSIC_PATHS = [
  '/',
  '/kingdom',
  '/bank',
  '/support',
  '/tower',
  '/hospital',
  '/woodhouse',
  '/wheatfarm',
  '/stonefactory',
  '/training',
  '/hunting-lodge',
  '/blacksmith',
  '/iron-mine',
  '/bakery',
  '/well',
  '/wall',
  '/map',
  '/espionage',
  '/counter-espionage',
  '/alliance',
  '/gem-pack',
  '/world-map',
]

function isKingdomRoute(pathname: string): boolean {
  if (KINGDOM_MUSIC_PATHS.includes(pathname)) return true
  if (pathname.startsWith('/kingdom/')) return true
  if (pathname.startsWith('/alliance/')) return true
  return false
}

export const KingdomMusicPlayer: React.FC = () => {
  const location = useLocation()
  const backgroundMusicEnabled = useSelector((state: RootState) => state.app.settings.backgroundMusicEnabled)
  const musicVolume = useSelector((state: RootState) => state.app.settings.musicVolume)
  const musicDucked = useSelector((state: RootState) => state.app.settings.musicDucked)

  const isKingdom = isKingdomRoute(location.pathname)
  const shouldPlay = backgroundMusicEnabled && isKingdom && !musicDucked

  const audioRef = useAudioPlayer({
    backgroundMusicEnabled: shouldPlay,
    musicVolume,
  })

  useLayoutEffect(() => {
    kingdomMusicAudioEl = audioRef.current
    return () => {
      kingdomMusicAudioEl = null
    }
  }, [])

  return (
    <audio
      ref={audioRef}
      src={AUDIO_LAND_URL}
      loop
      preload="metadata"
      onError={(e) => {
        console.error('Kingdom music loading error:', e)
      }}
    />
  )
}
